// /** @jsxImportSource @emotion/react */
import { useTheme } from '@mui/material/styles'
import { StyledBadge } from './Badge.styles'

interface BadgeProps {
  children: React.ReactNode
  variant?: 'default' | 'info' | 'success' | 'warning' | 'error'
  className?: string
}

export const Badge = ({ children, variant = 'default', className }: BadgeProps) => {
  const theme = useTheme()
  return (
    <StyledBadge theme={theme} variant={variant} className={className}>
      {children}
    </StyledBadge>
  )
}
